import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { RULES } from 'constants/rules.ts';

import Button from 'components/Button';
import Input from 'components/Input';
import Navigator from 'components/Navigator';
import Typography from 'components/Typography';

import { useSimulatorStore } from 'store/useSimulatorStore.ts';

import {
  ClientDataMailButton,
  ClientDataMailContainer,
  ClientDataMailContent,
  ClientDataMailTitle,
} from './ClientDataMail.styled.ts';

type FormData = {
  correo: string;
};

const ClientDataMail = () => {
  const navigate = useNavigate();

  const { form, saveClientDataMail } = useSimulatorStore();

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<FormData>({
    defaultValues: form || {
      correo: '',
    },
    mode: 'onChange',
  });

  const onSubmit = (data: FormData) => {
    saveClientDataMail(data);
    navigate('/datos-cliente/otp/correo');
  };

  return (
    <>
      <Navigator title="Cotizar préstamo" />
      <ClientDataMailContainer>
        <ClientDataMailContent>
          <ClientDataMailTitle>
            <Typography type="Title" size="small" style="semibold">
              Datos del cliente
            </Typography>
            <Typography type="Body" size="small" style="light" color="#5C5C5C">
              Ahora pídele su correo electrónico para verificarlo también.
            </Typography>
          </ClientDataMailTitle>

          <Controller
            name="correo"
            control={control}
            rules={RULES.email}
            render={({ field: { onChange, value } }) => {
              return (
                <Input
                  title="Correo electrónico"
                  placeholder="Correo electrónico"
                  maxLength={30}
                  variant="outlined"
                  value={value}
                  onChange={onChange}
                  isValid={!errors.correo?.message && value?.length > 0}
                />
              );
            }}
          />
        </ClientDataMailContent>

        <ClientDataMailButton>
          <Button
            variant="primary"
            onClick={handleSubmit(onSubmit)}
            disabled={!isValid}
          >
            Verificar correo
          </Button>
        </ClientDataMailButton>
      </ClientDataMailContainer>
    </>
  );
};

export default ClientDataMail;
